
export const MEMBER_COUNT = 2130;
export const VISIT_COUNT = 2290;
// export const TASK_COUNT = 4414;

// The Hosting deploy injects the current five-star visit count into the build.
const buildReviewCount = Number(process.env.REACT_APP_REVIEW_COUNT);
export const REVIEW_COUNT =
  Number.isSafeInteger(buildReviewCount) && buildReviewCount > 0
    ? buildReviewCount
    : 2355;

// Deploy-time credibility snapshot; fallbacks are the last verified values.
const buildAverageRating = Number(process.env.REACT_APP_AVERAGE_RATING);
export const AVERAGE_RATING = Number.isFinite(buildAverageRating) && buildAverageRating >= 1 && buildAverageRating <= 5
  ? buildAverageRating : 4.951926897099722;
const buildCitiesServed = Number(process.env.REACT_APP_CITIES_SERVED);
export const CITIES_SERVED = Number.isSafeInteger(buildCitiesServed) && buildCitiesServed > 0
  ? buildCitiesServed : 505;
const buildCompletedHelperHours = Number(process.env.REACT_APP_COMPLETED_HELPER_HOURS);
export const COMPLETED_HELPER_HOURS = Number.isSafeInteger(buildCompletedHelperHours) && buildCompletedHelperHours > 0
  ? buildCompletedHelperHours : 10630;
export const LAUNCH_YEAR = 2022;

export const SENTIMENT_SCALES = {
  agreement: [
    "Strongly Disagree",
    "Disagree",
    "Neutral",
    "Agree",
    "Strongly Agree",
  ],
  emotion: [
    "Very Negative",
    "Negative",
    "Neutral",
    "Positive",
    "Very Positive",
  ],
  likelihood: ["Very Unlikely", "Unlikely", "Neutral", "Likely", "Very Likely"],
  usability: ["Terrible", "Poor", "Average", "Good", "Excellent"],
  importance: [
    "Not Important",
    "Low Importance",
    "Neutral",
    "Important",
    "Very Important",
  ],
};
